/**
 * Manual + cancelled Razorpay subs: Mongo has only cancelledAt.
 * Access end and banner timing use cancelledAt + 1 month (never store endingAt/accessEndsAt).
 */
export function getAccessEndFromCancelledAt(cancelledAt) {
  const end = new Date(cancelledAt);
  end.setMonth(end.getMonth() + 1);
  return end;
}

/** YYYY-MM-DD for date inputs from cancelledAt-derived access end */
export function formatAccessEndDateInputValue(cancelledAt) {
  if (!cancelledAt) return '';
  const end = getAccessEndFromCancelledAt(cancelledAt);
  const y = end.getFullYear();
  const m = String(end.getMonth() + 1).padStart(2, '0');
  const d = String(end.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * @returns {{ finalMonthStart: Date, accessEnd: Date, today: Date } | null}
 */
function getCancelledSubscriptionAccessWindow(subscription, today = new Date()) {
  if (!subscription?.cancelledAt) return null;

  const cancelledAt = new Date(subscription.cancelledAt);
  const accessEndRaw = getAccessEndFromCancelledAt(cancelledAt);

  return {
    finalMonthStart: startOfDay(cancelledAt),
    accessEnd: startOfDay(accessEndRaw),
    today: startOfDay(today)
  };
}

function computeDaysRemainingInBannerWindow(window) {
  const { finalMonthStart, accessEnd, today } = window;
  if (today < finalMonthStart || today >= accessEnd) return null;

  const daysLeft = Math.ceil((accessEnd - today) / (1000 * 60 * 60 * 24));
  return daysLeft >= 0 ? daysLeft : null;
}

/**
 * Days until access ends for cancelled subscriptions.
 * Banner only during the final month: from cancelledAt until accessEnd.
 */
export function getExpiryBannerDaysRemaining(subscription, today = new Date()) {
  const status = String(subscription?.status || '').toLowerCase();
  if (status !== 'cancelled') return null;

  const window = getCancelledSubscriptionAccessWindow(subscription, today);
  if (!window) return null;

  return computeDaysRemainingInBannerWindow(window);
}

/**
 * Admin manual-subscriptions table status (computed, not stored in DB).
 */
export function getManualSubscriptionCurrentStatus(subscription, today = new Date()) {
  const window = getCancelledSubscriptionAccessWindow(subscription, today);
  if (!window) {
    return { type: 'unknown' };
  }

  if (window.today >= window.accessEnd) {
    return { type: 'ended' };
  }

  const daysRemaining = getExpiryBannerDaysRemaining(subscription, today);
  if (daysRemaining != null) {
    return { type: 'banner_active', daysRemaining };
  }

  return { type: 'ongoing' };
}
